export const paths = {
  ANNOUNCEMENTS: "announcements",
  ANNOUNCEMENTS_USER: "announcements/staff",
  INVESTIGATORS: "staff",
  GROUPS: "investigation-groups",
  RESEARCHLINES: "research-lines",
  LINES: "research-lines",
  INVESTROLE: "investigator-roles",
  USERROLE: "user-roles",
  USERS: "users",
  PROJECTS: "projects",
  investigatorPROJECT: "staff/project",
  researchLinePROJECT: "project/research-lines",
  OTROS: "otros",
  investigatorOTRO: "staff/otro",
  researchLineOTRO: "otro/research-lines",
  SUBJECTS: "subjects",
  INVESTIGATOR_SUBJECT: "staff/subject",
  PROGRAMS: "programs",
  newUsers: "staff/users",
  TEACHING_RESOURCE: "teaching-resources",
  TEACHING_RESOURCEDOCUMENTS: "teachingResources-documents/teachingResources",
  investigatorGROUP: "staff/investigation-group",
  investigatorResearchLine: "staff/research-lines",
  PUBLICATIONS: "publications",
  investigatorPUBLICATION: "staff/publication",
  DEGREES: "degrees",
  DEGREE_TYPES: "degree-types",
  groupPUBLICATION: "investigation-group/publication",
  publicationsByGROUP: "publications/investigation-group",
  publicationsINVESTIGATOR: "publications/staff",
  NEWPASSWORD: "auth/change-password",
  groupSelectPUBLICATION: "investigation-group",
  userSelectPUBLICATION: "staff",
  RESETPASSWORD: "auth/reset-password/user",
  COMMISSIONS: "commissions",
  PATENTS: "patents",
  investigatorPATENT: "staff/patents",
  OFFERS: "offers",
  STAFF_COMMISSION: "staff/commission",
  SLIDERS: "sliders",
  RESOURCES: "resources",
  RESOURCEFOLDER: "resource-folders",
  INTRANETS: "intranets",
  INTRANETFOLDER: "intranet-folders",
  INVESTIGADORES_INVITADOS: "investigadores-invitados",
  COREFACILITIES: "coreFacilities",
  investigatorCOREFACILITIES: "staff/coreFacility",
};
